import _objectWithoutProperties from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _asyncToGenerator from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator";
import { FlattenedSign } from '../flattened/sign.js';
import { JWSInvalid } from '../../util/errors.js';

var IndividualSignature = /*#__PURE__*/function () {
  function IndividualSignature(sig, key, options) {
    _classCallCheck(this, IndividualSignature);

    this.parent = sig;
    this.key = key;
    this.options = options;
  }

  _createClass(IndividualSignature, [{
    key: "setProtectedHeader",
    value: function setProtectedHeader(protectedHeader) {
      if (this.protectedHeader) {
        throw new TypeError('setProtectedHeader can only be called once');
      }

      this.protectedHeader = protectedHeader;
      return this;
    }
  }, {
    key: "setUnprotectedHeader",
    value: function setUnprotectedHeader(unprotectedHeader) {
      if (this.unprotectedHeader) {
        throw new TypeError('setUnprotectedHeader can only be called once');
      }

      this.unprotectedHeader = unprotectedHeader;
      return this;
    }
  }, {
    key: "addSignature",
    value: function addSignature() {
      var _this$parent;

      return (_this$parent = this.parent).addSignature.apply(_this$parent, arguments);
    }
  }, {
    key: "sign",
    value: function sign() {
      var _this$parent2;

      return (_this$parent2 = this.parent).sign.apply(_this$parent2, arguments);
    }
  }, {
    key: "done",
    value: function done() {
      return this.parent;
    }
  }]);

  return IndividualSignature;
}();

export var GeneralSign = /*#__PURE__*/function () {
  function GeneralSign(payload) {
    _classCallCheck(this, GeneralSign);

    this._signatures = [];
    this._payload = payload;
  }

  _createClass(GeneralSign, [{
    key: "addSignature",
    value: function addSignature(key, options) {
      var signature = new IndividualSignature(this, key, options);

      this._signatures.push(signature);

      return signature;
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var jws, i, signature, flattened, _yield$flattened$sign, payload, rest;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._signatures.length) {
                  _context.next = 2;
                  break;
                }

                throw new JWSInvalid('at least one signature must be added');

              case 2:
                jws = {
                  signatures: [],
                  payload: ''
                };
                i = 0;

              case 4:
                if (!(i < this._signatures.length)) {
                  _context.next = 24;
                  break;
                }

                signature = this._signatures[i];
                flattened = new FlattenedSign(this._payload);
                flattened.setProtectedHeader(signature.protectedHeader);
                flattened.setUnprotectedHeader(signature.unprotectedHeader);
                _context.next = 11;
                return flattened.sign(signature.key, signature.options);

              case 11:
                _yield$flattened$sign = _context.sent;
                payload = _yield$flattened$sign.payload;
                rest = _objectWithoutProperties(_yield$flattened$sign, ["payload"]);

                if (!(i === 0)) {
                  _context.next = 18;
                  break;
                }

                jws.payload = payload;
                _context.next = 20;
                break;

              case 18:
                if (!(jws.payload !== payload)) {
                  _context.next = 20;
                  break;
                }

                throw new JWSInvalid('inconsistent use of JWS Unencoded Payload Option (RFC7797)');

              case 20:
                jws.signatures.push(rest);

              case 21:
                i++;
                _context.next = 4;
                break;

              case 24:
                return _context.abrupt("return", jws);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign() {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }]);

  return GeneralSign;
}();